import { route } from 'typesafe-routes';

export default route('/about', {}, {});
